export const useBarChartStyles = () => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        },
        title: {
            color: 'white',
            fontWeight: 400,
            fontSize: '12px'
        },
        chartContainer: {
            position: 'relative',
            flexGrow: 1
        },
        legend: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: 1,
            mt: 2
        },
        legendItem: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        legendColor: {
            width: 12,
            height: 12,
            borderRadius: '50%'
        },
        legendText: {
            color: 'white',
            fontSize: '0.875rem'
        }
    };
};
